import React, { useState } from 'react';

import SatInput from '@components/common/satUI/SatInput';
import SatDatePicker from '@components/common/satUI/SatDatePicker';
import { getToday, addDates } from '@common/utils/date';
import SatSelect from '@components/common/satUI/SatSelect';

const AppListHeader = props => {
  const {
    searchParams: { startDate, endDate, customerName, compCd },
    onChangeSearchParams,
  } = props;

  const [customerNameInput, setCustomerNameInput] = useState(customerName);

  return (
    <div className="tbl-header">
      {/* <!-- 2022.02.15: data-group-left 추가 --> */}
      <div className="data-group-left">
        <div className="data-area">
          <span className="data-tit">조회기간</span>
          <SatDatePicker
            size={'small'}
            value={startDate}
            disabledDates={[
              addDates(getToday(), 'year', -1, 'yyyyMMdd'),
              endDate,
            ]}
            onChange={value => onChangeSearchParams('startDate', value)}
            noDisableCss={true}
          />
          <span className="tilde">~</span>
          <SatDatePicker
            size={'small'}
            value={endDate}
            disabledDates={[startDate, getToday('yyyyMMdd')]}
            onChange={value => onChangeSearchParams('endDate', value)}
            noDisableCss={true}
          />
        </div>
      </div>

      <div className="right-area">
        {/* 20230913 회사 선택 삭제 */}
        {/* <SatSelect
          title={'회사선택'}
          value={compCd}
          options={[
            { label: '전체', value: 'ALL' },
            { label: '구.KB', value: PRODUCT_COMP_CD.kb },
            { label: '구.푸르덴셜', value: PRODUCT_COMP_CD.pr },
          ]}
          initOption={{ label: '', value: '', useOption: false }}
          readOnly={false}
          onChange={value => onChangeSearchParams('compCd', value.value)}
          // validRule={[
          //   {
          //     rule: () => !row.validErrStatus.includes('payinPeriodInfo'),
          //   },
          // ]}
          size="small"
          border={true}
        /> */}
        <div className="sch-box">
          <SatInput
            type={'search'}
            value={customerNameInput}
            placeholder={'이름으로 고객을 검색하세요.'}
            onChange={setCustomerNameInput}
            onPressEnter={() =>
              onChangeSearchParams('customerName', customerNameInput)
            }
            onBlur={() =>
              onChangeSearchParams('customerName', customerNameInput)
            }
          />
        </div>
      </div>
    </div>
  );
};

export default AppListHeader;
